"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/RichMessageWrapper/ReactionChips.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _reactions = require('shared/services/reactions');
var _Tooltip = require('web/components/Tooltip');

const NO_REACTIONS = []
























const ReactionChip = ({
  group,
  messageKey,
  conversationKey,
  onAddReaction,
  onRemoveReaction,
  readOnly,
}) => {
  const { emoji, isOwn } = group
  const handleClick = _react.useCallback.call(void 0, 
    () => isOwn
      ? onRemoveReaction(messageKey, emoji, conversationKey)
      : onAddReaction(messageKey, emoji, conversationKey),
    [isOwn, emoji, messageKey, conversationKey, onAddReaction, onRemoveReaction],
  )

  return (
    _react2.default.createElement(_Tooltip.HoverTooltip, {
      type: "dark",
      place: "top",
      content: (
        _react2.default.createElement('div', { className: "rich-message--reaction-tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          , group.reactorNames.join(', ')
        )
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}

      , _react2.default.createElement('button', {
        type: "button",
        className: _classBuilder2.default.call(void 0, 
          "rich-message--reaction-chip",
          isOwn && "rich-message--reaction-chip--own",
          readOnly && "rich-message--reaction-chip--readonly",
        ),
        // Existing reactions stay visible over the limit — they are part of
        // the history — but toggling one is a write, so it is inert.
        disabled: readOnly,
        onClick: handleClick,
        'aria-label': `${emoji} reaction, ${group.count}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}

        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}, emoji)
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}, group.count)
      )
    )
  )
}

const ReactionChips = ({
  reactions = NO_REACTIONS,
  currentUserKey,
  messageKey,
  conversationKey,
  deleted,
  subscribers,
  onAddReaction,
  onRemoveReaction,
  readOnly,
}) => {
  const groups = _react.useMemo.call(void 0, 
    () => _reactions.groupReactions.call(void 0, 
      reactions,
      currentUserKey,
      key => _optionalChain([subscribers, 'optionalAccess', _ => _[key], 'optionalAccess', _2 => _2.Name]),
    ),
    [reactions, currentUserKey, subscribers],
  )

  if (deleted || groups.length === 0) return null

  return (
    _react2.default.createElement('div', { className: "rich-message--reactions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
      , groups.map(group => (
        _react2.default.createElement(ReactionChip, {
          key: group.emoji,
          group: group,
          messageKey: messageKey,
          conversationKey: conversationKey,
          onAddReaction: onAddReaction,
          onRemoveReaction: onRemoveReaction,
          readOnly: readOnly, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
        )
      ))
    )
  )
}

// Memoized: the row re-renders on hover and menu state, which never changes
// the chips' inputs.
exports. default = _react2.default.memo(ReactionChips)
